export const leakSeverityBundle = {
  title: { ko: "누수 심각도 현황", en: "Leak Severity Status", es: "Estado de gravedad de fugas" },
  legends: [
    { en: "minor", ko: "미세", es: "Leve", color: "#73bfb8" },
    { en: "caution", ko: "주의", es: "Precaución", color: "#e9a851" },
    { en: "severe", ko: "심각", es: "Grave", color: "#d64550" }
  ]
}
